import R from 'ramda'
import { getIndentedJSONString } from 'pages/widgets/mapping/common-functions'

const CALL_ENDPOINT_ACTION_TYPE = 'CALL_ENDPOINT'
const CALL_ENDPOINT_DISPLAY_TYPE = 'Call endpoint'

const isCallEndpointWidgetAction = R.propEq('type', CALL_ENDPOINT_ACTION_TYPE)

const propIsString = propertyName => R.pipe(R.prop(propertyName), R.is(String))

const parseProp = propertyName => R.pipe(R.prop(propertyName), JSON.parse)

const getData = R.ifElse(
  propIsString('data'),
  R.pipe(
    R.applySpec({
      body: parseProp('data')
    }),
    getIndentedJSONString
  ),
  R.pipe(
    R.applySpec({
      headers: R.prop('headers'),
      body: R.ifElse(propIsString('body'), parseProp('body'), R.prop('body')),
      form: R.prop('form'),
      query: R.prop('query'),
      timeout: R.prop('timeout'),
      retry: R.prop('retry')
    }),
    getIndentedJSONString
  )
)

const convertCallEndpointWidgetActionToFormAction = R.applySpec({
  type: R.always(CALL_ENDPOINT_DISPLAY_TYPE),
  method: R.prop('method'),
  url: R.prop('url'),
  data: getData
})

export {
  isCallEndpointWidgetAction,
  convertCallEndpointWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/call-endpoint.js